import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { applyDocumentHead } from './applyDocumentHead';
import { resolveRouteSeo } from './resolveRouteSeo';

/** Sync document title/meta/canonical/OG with the current SPA route. */
export function DocumentHead() {
  const location = useLocation();

  useEffect(() => {
    applyDocumentHead(resolveRouteSeo(location.pathname));
  }, [location.pathname]);

  return null;
}
